import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ProfileFacadeService } from 'src/app/shared/services/profile/profile-facade.service';

@Injectable()
export class ConditionsGuard implements CanActivate {
  public acceptationStatus: boolean;
  constructor(private profileService: ProfileFacadeService, private router: Router) { };

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return new Promise((resolve, reject) => {
      this.profileService.getPreInitials().subscribe(
        data => {
          if (this.router.url.includes('admin_login')) this.acceptationStatus = true;
          else this.acceptationStatus = data.condition_acceptation;
          resolve(this.acceptationStatus)
        }, error => {
          reject();
        }
      )
    })
  }

  get conditions() {
    return this.acceptationStatus;
  }

  set conditions(info) {
    this.acceptationStatus = info;
  }
}



